import { IResponse } from './response'

export default async function(response: Response): Promise<boolean> {
  const json: IResponse = await response.json()
  const result = json.items.result !== -1

  if (result) {
    return true
  }

  throw new Error('errStatus_13')
}
